import script from "./AutoInvoiceConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoInvoiceConfig.vue?vue&type=script&setup=true&lang=js"

import "./AutoInvoiceConfig.vue?vue&type=style&index=0&id=39efa753&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39efa753"]])

export default __exports__